import React from 'react';
import {withStyles} from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import IconButton from "@material-ui/core/IconButton";
import Icon from "@material-ui/core/Icon";

import i18n from '../../i18n';
import Layout from '../../components/Layout';
import Toolbar from "../../components/Toolbar/Toolbar";
import Table from "@material-ui/core/Table";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import TableCell from "@material-ui/core/TableCell";
import TableBody from "@material-ui/core/TableBody";
import DeleteButton from "../../components/Form/DeleteButton";
import FilterForm from "../../components/Form/FilterForm";

import {
    withPaginator,
    Pagination
} from '../../components/Pagination';
import {FormattedNumber} from "react-intl";

const LifeCycleIndex = ({classes, items, filter}) => (
    <Layout>
        <Toolbar
            disableGutters
            title={i18n.get('life_cycle.title')}
            items={[
                {
                    icon: 'add',
                    text: i18n.get('life_cycle.add'),
                    href: '/life-cycle-rates/create',
                }
            ]}
        >
            <FilterForm
                url="/life-cycle-rates"
                filter={filter}
                inputPlaceholder={i18n.get('life_cycle.form.search_value')}
                buttonTitle={i18n.get('life_cycle.form.search')}
            />
        </Toolbar>

        <Paper className={classes.paper}>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell scope="col">{i18n.get('life_cycle.form.name')}</TableCell>
                        <TableCell scope="col">{i18n.get('life_cycle.form.rate')}</TableCell>
                        <TableCell scope="col">{i18n.get('life_cycle.form.actions')}</TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {items.map(lifeCycleRate => (
                        <TableRow key={lifeCycleRate.id}>
                            <TableCell>{lifeCycleRate.name}</TableCell>
                            <TableCell>
                                <FormattedNumber
                                    value={lifeCycleRate.rate / 100}
                                    style="percent"
                                    maximumFractionDigits={2}
                                />
                            </TableCell>
                            <TableCell>
                                <IconButton
                                    component="a"
                                    href={`/life-cycle-rates/${lifeCycleRate.id}/edit`}
                                >
                                    <Icon>edit</Icon>
                                </IconButton>

                                <DeleteButton
                                    confirmMessage={i18n.get('life_cycle.delete.confirm')}
                                    successMessage={i18n.get('life_cycle.delete.success')}
                                    errorMessage={i18n.get('life_cycle.delete.error')}
                                    href={`/life-cycle-rates/${lifeCycleRate.id}`}
                                />
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>

                <Pagination colSpan={3}/>
            </Table>
        </Paper>
    </Layout>
);

const styles = theme => ({
    paper: {
        marginBottom: theme.spacing.unit * 3,
        padding: theme.spacing.unit * 2,
        [theme.breakpoints.up(600 + theme.spacing.unit * 3 * 2)]: {
            marginBottom: theme.spacing.unit * 6,
            padding: theme.spacing.unit * 3,
        },
    },
});

export default withStyles(styles)(
    withPaginator('lifeCycleRates')(LifeCycleIndex)
);



// WEBPACK FOOTER //
// ./resources/assets/js/pages/lifeCycle/Index.jsx